import AppDownloadLinkPanel from '../../components/molecules/panels/AppDownloadLinkPanel'
export default {
  components: { AppDownloadLinkPanel },
  methods: {
    onClickBackToTopLink() {
      window.scrollTo({ top, behavior: 'smooth' })
      event.preventDefault()
    },
    onClickBackToAnnouncementsLink() {
      window.history.back()
    }
  }
}
